import { useState } from 'react';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import SearchIcon from '../../assets/ic_search.png';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import './EditorList.scss';
import { useHistory } from 'react-router-dom';
import { deleteEditor, useGetEditors } from '../../api/editor';
import RoundButton from '../../components/RoundButton';
import EditIcn from '../../assets/edit_icn.svg';
import Delete from '../../assets/Delete.png';
import { _showAlert } from '../../utils';
import AlertModal from '../../components/Modal';
import SortIndicator from '../../components/SortIndicator';

/**
 * material ui table style
 */
const useStyles = makeStyles({
  table: {
    minWidth: 700,
    borderRadius: 30,
  },
});

function EditorList() {
  const classes = useStyles();
  const history = useHistory();

  const [searchEditor, setSearchEditor] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedEditor, setSelectedEditor] = useState(null);

  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const { editors, isEditorsEmpty, mutateEditors } = useGetEditors(searchEditor);

  const handleSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (sortConfig.key === key) {
      if (sortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setSortConfig({ key: newKey, direction });
  };

  const sortEditors = (editorsList) => {
    if (!sortConfig.key || !Array.isArray(editorsList)) return editorsList;

    return [...editorsList].sort((a, b) => {
      const key = sortConfig.key;
      const valueA = (a[key] || '').toString();
      const valueB = (b[key] || '').toString();

      return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  };

  const handleDelete = async (editor) => {
    try {
      await deleteEditor([editor.id]);
      await mutateEditors();
      setOpenDeleteModal(false);
      _showAlert('Editor deleted successfully', 'success', 3000);
    } catch (error) {
      _showAlert(error?.response?.data?.message || 'Error deleting editor', 'error', 3000);
    }
  }

  return (
    <>
      <AlertModal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)} handelDelete={() => handleDelete(selectedEditor)} />

      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="leftPortion">
          <NavBar data="All Editors" currentRouteName="Editors" breadcrumbsPath="Editors List" />
          <div className="content">
            <div className="search_row_container">
              <div className="search_row">
                <input
                  className="input_field"
                  placeholder="search something Here..."
                  type="text"
                  value={searchEditor}
                  onChange={(e) => setSearchEditor(e.target.value)}
                />
                <img alt="Hello" src={SearchIcon} />
              </div>
              <RoundButton handleClick={() => history.push('/new-editor')} btnText="New Editor" />
            </div>
            <TableContainer className="tbl_wraper editor-list-main" component={Paper}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell className="table_font">Result</TableCell>
                    <TableCell
                      onClick={() => handleSort('name')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Name<SortIndicator sortConfig={sortConfig} columnKey="name" />
                    </TableCell>
                    <TableCell
                      onClick={() => handleSort('email')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Email<SortIndicator sortConfig={sortConfig} columnKey="email" />
                    </TableCell>
                    <TableCell
                      onClick={() => handleSort('username')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Username<SortIndicator sortConfig={sortConfig} columnKey="username" />
                    </TableCell>
                    <TableCell>Address</TableCell>
                    <TableCell
                      onClick={() => handleSort('firstname')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      First Name<SortIndicator sortConfig={sortConfig} columnKey="firstname" />
                    </TableCell>
                    <TableCell
                      onClick={() => handleSort('lastname')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Last Name<SortIndicator sortConfig={sortConfig} columnKey="lastname" />
                    </TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(editors) &&
                    sortEditors(editors).map((editor, index) => (
                      <TableRow key={editor.id}>
                        <TableCell style={{ fontWeight: 'bold' }}>#{++index}</TableCell>
                        <TableCell>{editor.name || 'N/A'}</TableCell>
                        <TableCell>{editor.email || 'N/A'}</TableCell>
                        <TableCell>{editor.username || 'N/A'}</TableCell>
                        <TableCell>{editor.address || 'N/A'}</TableCell>
                        <TableCell>{editor.firstname || 'N/A'}</TableCell>
                        <TableCell>{editor.lastname || 'N/A'}</TableCell>
                        <TableCell>{editor.phone || 'N/A'}</TableCell>
                        <TableCell style={{ cursor: 'pointer' }}
                          align='center'
                        >
                          <span className="editor_action_icn">
                            <img alt="Edit" src={EditIcn} onClick={() => {
                              history.push('/update-editor', { editorData: editor });
                            }} />
                            <img alt="Delete" src={Delete} onClick={() => {
                              setSelectedEditor(editor);
                              setOpenDeleteModal(true);
                            }} />
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  {isEditorsEmpty && (
                    <TableRow>
                      <TableCell colSpan={8} style={{ textAlign: 'center' }}>No editors found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
      {/* {isDeletePopUpVisible && (
        <DeleteCustomerPopup selectedCustomer={selectedCustomer} setIsDeletePopUpVisible={setIsDeletePopUpVisible} />
      )} */}
    </>
  );
}

export default EditorList;

